import { JobStatus } from 'common/BulkLoading';

export const JOB_STATUS_KEY = 'prescriptionGenerationJobStatus';
export const PRESCRIPTION_GENERATION_JOB_POLLING_INTERVAL = 2;
export const IN_PROGRESS_JOB_STATUS =  [JobStatus.EXECUTING, JobStatus.PENDING];
